import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import CloseButton from 'react-bootstrap/CloseButton';

import './HelpPanel.css';

function HelpPanel({ show, close, category }) {
    const { t } = useTranslation();
    const panelRef = useRef();

    useEffect(() => {
      function handleClickOutside(event) {
        if (show && panelRef.current && !panelRef.current.contains(event.target)) {
          close();
        }
      }

      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [show, close]);

    if (!show) return null;

    return (
      <div className="help-panel" ref={panelRef}>
        <div className="help-header">
          <h3>{t(`categories.${category}.title`)}</h3>
          <CloseButton onClick={close} />
        </div>
        <div
          className="help-body"
          dangerouslySetInnerHTML={{ __html: t(`help.${category}.html`) }}
        />
      </div>
    );
}

export default HelpPanel;